module.exports = __webpack_public_path__ + "img/fabrica.f184c564.svg";